import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Vote } from 'lucide-react';
import { SKUS_50, VARIANTS, ASSETS } from '../lib/products';
import ProductCard from '../components/ProductCard';
import KrispButton from '../components/KrispButton';
import FloatingChips from '../components/FloatingChips';

export const MysteryCard = ({ index = 2, variant = VARIANTS[0] }) => (
  <motion.div data-testid={`pack-card-flavour-3${variant.id === '100g' ? '-100g' : ''}`} initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: '-40px' }} transition={{ duration: 0.5, delay: (index % 3) * 0.08 }}
    className="card-pop relative rounded-3xl bg-cocoa text-cream border-2 border-cocoa p-5 flex flex-col overflow-hidden">
    <div className="absolute inset-x-0 top-0 h-2 bg-[#E0632A]" />
    <span className="absolute top-5 left-4 z-10 rounded-full px-3 py-1 text-[10px] font-black tracking-[0.2em] bg-kyellow text-cocoa">FLAVOUR #3 · {variant.name}</span>
    <div className="pt-12 pb-4 chip-drift" style={{ '--t': '7s', '--r': '0deg' }}>
      <img src={ASSETS.soon} alt="PROKRISP Flavour #3 coming soon" loading="lazy" className="h-60 mx-auto object-contain gpu" data-testid="mystery-pack-img" />
    </div>
    <p className="font-display text-3xl leading-none">COMING SOON</p>
    <p className="font-cond text-[11px] tracking-[0.22em] text-cream/60 mt-1">STAY TUNED · SALT & PEPPER · TOMATO · SWEET CHILLI · PUDINA</p>
    <div className="flex items-end justify-between mt-4">
      <p className="font-display text-3xl leading-none text-kyellow">₹{variant.price}</p>
      <span className="rounded-full border-2 border-cream/20 px-2.5 py-1 text-[9px] font-black tracking-widest text-cream/60">YOU DECIDE</span>
    </div>
    <Link to="/vote" className="relative mt-4"><KrispButton testid={`pack-vote-flavour-3${variant.id === '100g' ? '-100g' : ''}`} className="w-full !py-3 !text-sm"><Vote size={16} /> VOTE NOW →</KrispButton></Link>
  </motion.div>
);

const Zone = ({ v, skus, flip }) => (
  <div id={`zone-${v.id}`} data-testid={`zone-${v.id}`} className="pt-14 scroll-mt-24">
    <div className={`flex flex-col ${flip ? 'md:flex-row-reverse' : 'md:flex-row'} md:items-end justify-between gap-4`}>
      <div className={`inline-flex items-end gap-4 rounded-[2rem] bg-cocoa text-cream px-8 py-5 border-2 border-cocoa shadow-[8px_8px_0_#F7B500] ${flip ? 'rotate-1' : '-rotate-1'} self-start`}>
        <span className="font-display text-7xl md:text-8xl leading-none text-kyellow">{v.name}</span>
        <div className="pb-2">
          <p className="font-display text-2xl leading-none">{v.protein} PROTEIN</p>
          <p className="font-cond text-[10px] tracking-[0.3em] text-cream/60 mt-1">{v.sub} · ₹{v.price}</p>
        </div>
      </div>
      <p className={`font-cond text-sm tracking-[0.25em] text-cocoa/60 max-w-xs ${flip ? 'md:text-left' : 'md:text-right'}`}>
        NOW LIVE. ₹50 A PACK · MINIMUM ORDER 3 PACKETS · SHIPPING CHARGES APPLICABLE.
      </p>
    </div>
    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-8">
      {skus.map((sku, i) => <ProductCard key={sku.key} sku={sku} index={i} />)}
      <MysteryCard variant={v} />
    </div>
  </div>
);

export default function Lineup({ showAll = false }) {
  return (
    <section id="lineup" data-testid="lineup-section" className="bg-cream px-5 md:px-14 pt-14 pb-16 relative overflow-hidden scroll-mt-24">
      <FloatingChips count={3} />
      <div className="relative max-w-[1500px] mx-auto">
        <motion.h2 initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
          className="font-display text-[15vw] md:text-[7vw] leading-[0.85] text-cocoa">
          THE<br /><span className="stroke-text">LINEUP.</span>
        </motion.h2>
        <Zone v={VARIANTS[0]} skus={SKUS_50} />
        {!showAll && (
          <div className="flex justify-center mt-12">
            <Link to="/products"><KrispButton testid="lineup-view-all" variant="dark">VIEW THE SHOP →</KrispButton></Link>
          </div>
        )}
      </div>
    </section>
  );
}
